import { observer } from 'mobx-react';
import { Suspense, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';

import { Spinner } from '@/components/Spinner';
import { useFetchClientListForPanel, useFetchUserDetail } from '@/services';

import { ChatStoreProvider, useChatStore } from '../store';
import { ChatContent, ChatFooter, ChatHeader, ChatLnb } from './index';

export default observer(function ChatContainer() {
  const { venueId, clientId } = useParams();
  const [searchParams] = useSearchParams();
  const store = useChatStore();

  const user = useFetchUserDetail();
  const { data: clientPanel } = useFetchClientListForPanel();
  const clientPanelContent = clientPanel?.content;

  const computedVenueId = venueId
    ? Number(venueId)
    : store.currentGroup.venueId;
  const getVenueIds = () => {
    const myClientsOnly = searchParams.get('my') === 'true';
    if (clientId) {
      return clientPanelContent
        ?.find((client) => client.id === Number(clientId))
        ?.venues.filter((venue) => venue.hasCleanierUser)
        .map((venue) => venue.id)
        .toString();
    } else if (myClientsOnly) {
      return user?.responsibleVenues?.map((venue) => venue.id).toString();
    } else {
      return clientPanelContent
        ?.map((client) =>
          client.venues
            .filter((venue) => venue.hasCleanierUser)
            .map((venue) => venue.id)
        )
        .flat()
        .toString();
    }
  };

  return (
    <ChatStoreProvider>
      <Suspense fallback={<Spinner />}>
        <div className="box-border flex h-chatModalHeight min-w-full w-full overflow-y-hidden rounded max-md:border-none">
          <ChatLnb
            computedVenueId={computedVenueId}
            getVenueIds={getVenueIds}
          />
          <div className="box-border flex flex-1 flex-col rounded-br-md rounded-tr-md border-[1px] border-l-0 border-solid border-[#ececec] pb-8 max-md:hidden md:overflow-x-hidden">
            <Suspense fallback={<Spinner />}>
              <ChatHeader getVenueIds={getVenueIds} />
              <Suspense fallback={<Spinner />}>
                <ChatContent />
                <ChatFooter getVenueIds={getVenueIds} />
              </Suspense>
            </Suspense>
          </div>
        </div>
      </Suspense>
    </ChatStoreProvider>
  );
});
